import { DUE_SOON_DAYS, NOTICE_DEADLINE_DAY } from "./constants";
import { addMonthsToMonth, daysBetween, monthOf } from "./dates";
import type { IsoDate, IsoMonth } from "./types";

const day = String(NOTICE_DEADLINE_DAY).padStart(2, "0");

/**
 * Deadline of a notice: day 17 of the month after the operation (for an
 * accumulated notice, after the operation that crossed the threshold).
 * 2026-03-05 → 2026-04-17; 2026-12-20 → 2027-01-17.
 */
export const noticeDeadline = (operationDate: IsoDate): IsoDate =>
  `${addMonthsToMonth(monthOf(operationDate), 1)}-${day}`;

/** A zero report for month M is due on day 17 of month M + 1, like a notice. */
export const zeroReportDeadline = (month: IsoMonth): IsoDate => `${addMonthsToMonth(month, 1)}-${day}`;

/** Days left until the deadline (0 = due today, negative = overdue). */
export const daysUntilDeadline = (deadline: IsoDate, today: IsoDate) => daysBetween(today, deadline);

export type DeadlineStatus = "filed" | "overdue" | "due_soon" | "on_time";

export function deadlineStatus(deadline: IsoDate, today: IsoDate, filed = false): DeadlineStatus {
  if (filed) return "filed";
  const days = daysUntilDeadline(deadline, today);
  if (days < 0) return "overdue";
  if (days <= DUE_SOON_DAYS) return "due_soon";
  return "on_time";
}
